/**
 * Basil color tokens. Every value is a CSS variable that resolves from the
 * ACTIVE daisyUI theme (see index.css + ThemePicker), so switching themes
 * reskins the whole app. The four desire doors stay fixed brand colors.
 */
export const C = {
  base: 'var(--b-base)',
  rail: 'var(--b-rail)',
  surface: 'var(--b-surface)',
  surface2: 'var(--b-surface-2)',
  elevated: 'var(--b-elevated)',
  hover: 'var(--b-hover)',
  line: 'var(--b-line)',
  lineSoft: 'var(--b-line-soft)',
  lineStrong: 'var(--b-line-strong)',
  faint: 'var(--b-faint)',
  muted: 'var(--b-muted)',
  secondary: 'var(--b-secondary)',
  primary: 'var(--b-text)',
  // Accent = theme primary.
  basil: 'var(--b-accent)',
  basilDeep: 'var(--b-accent-deep)',
  basilInk: 'var(--b-accent-ink)',
  // Semantic = theme semantic colors.
  good: 'var(--color-success)',
  watch: 'var(--color-warning)',
  act: 'var(--color-error)',
  info: 'var(--color-info)',
  // Desire doors — fixed brand identity.
  magic: '#a98be0',
  energy: '#dda95a',
  calm: '#6fa0ce',
  freedom: '#bbd0dc',
} as const;

/** Translucent version of any color (var or hex) — replaces the old `${hex}22` trick. */
export function alpha(color: string, pct: number): string {
  return `color-mix(in oklab, ${color} ${pct}%, transparent)`;
}

/** Mix a color into a base (default: the surface token). */
export function mix(color: string, pct: number, into: string = C.surface): string {
  return `color-mix(in oklab, ${color} ${pct}%, ${into})`;
}

/** Map a seed desire `color` name (see phuketCleanse seed) → a door color + label. */
export const DESIRE: Record<string, { color: string; door: string }> = {
  violet: { color: C.magic, door: 'MAGIC' },
  amber: { color: C.energy, door: 'ENERGY' },
  cool_blue: { color: C.calm, door: 'CALM' },
  sky_white: { color: C.freedom, door: 'FREEDOM' },
};

/** Map a desire `key` → its door color (fallback muted). */
export const DESIRE_BY_KEY: Record<string, string> = {
  magic: C.magic,
  energy: C.energy,
  calm: C.calm,
  freedom: C.freedom,
};
